var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.svgComponent,{tag:"component",attrs:{"svg-props":_vm.svgProps,"aspect-ratio":_vm.aspectRatio,"height":_vm.height,"width":_vm.width,"current-path":_vm.currentPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }